import { Component, OnInit, ViewChild } from '@angular/core';
import { RenewalRoommateInfo } from '../../models/renewal-roommate-info';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { RenewalCogService } from 'services/renewalcog.service';

@Component({
  selector: 'app-roommate-info-cog',
  templateUrl: './roommate-info-cog.component.html',
  styleUrls: ['./roommate-info-cog.component.css']
})
export class RoommateInfoCogComponent implements OnInit {

  model: RenewalRoommateInfo;
  displayIndex: number;
  displayCount: number;

  @ViewChild('roommateInfoForm', { static: true })
  roommateInfoForm: NgForm;

  constructor(
    private renewalService: RenewalCogService,
    public router: Router
  ) {
    this.model = new RenewalRoommateInfo();

    const RenewalKey = localStorage.getItem('RenewalKey');

    if (RenewalKey !== undefined && RenewalKey !== null) {

      this.model.LeaseRenewalKey = Number(RenewalKey);

      this.renewalService.getRenewalRoommateInfo(this.model)
        .subscribe(res => this.getRenewalRoommateInfo(res), err => this.renewalService.handleError(err));

    } else {
      this.renewalService.handleError("Error - unable to verify renewal key.");
    }

  }

  ngOnInit() {
  }

  async getRenewalRoommateInfo(roommateInfo: RenewalRoommateInfo) {
    this.model = roommateInfo;

    if (this.model.TotalRoommates == 0) {
      this.router.navigate(['/renewalcog/renewal-review/employment-info']);
    }

    this.displayCount = this.model.TotalRoommates;
    this.displayIndex = this.model.RoommateIndex + 1;
  }

  backButton() {
    this.model.RoommateIndex--;
    this.renewalService.getRenewalRoommateInfo(this.model)
      .subscribe(res => this.getRenewalRoommateInfo(res), err => this.renewalService.handleError(err))
  }

  onSubmit() {
    if (this.roommateInfoForm.valid) {
      this.renewalService.updateRenewalRoommateInfo(this.model)
        .subscribe(res => this.onUpdateSuccess(),
          err => this.renewalService.handleError(err));
    } else {
      this.renewalService.handleError("Error updating rooommate information.");
    }
  }

  onUpdateSuccess() {
    var adjustedCount = this.model.TotalRoommates - 1;

    if (this.model.RoommateIndex == adjustedCount) {
      localStorage.removeItem('RoommateIndex');
      this.router.navigate(['/renewalcog/renewal-review/employment-info']);
    }
    else if (this.model.RoommateIndex < adjustedCount) {
      this.model.RoommateIndex++;
      this.renewalService.getRenewalRoommateInfo(this.model)
        .subscribe(res => this.getRenewalRoommateInfo(res), err => this.renewalService.handleError(err))
    }
    else {
      this.renewalService.handleError("Error updating rooommate information.");
    }

  }
}
